import PropTypes from 'prop-types'
import { baseSlicePropTypes } from '../slice.types'

/**
 * @typedef {Object} Zone
 * @property {string} id
 * @property {string} name
 * @property {string} notes
 * @property {string[]} countries - Array of country codes (API format)
 * @property {string} countries_inclusion_type
 * @property {string} states_provinces_inclusion_type
 * @property {string[]} states_provinces - Array of state/province codes (API format)
 * @property {string} cities_inclusion_type
 * @property {string} cities
 * @property {string} zip_codes_inclusion_type
 * @property {string} zip_codes
 * @property {string[]} carrier_services
 *
 * Note: During form editing, countries and states_provinces are arrays of
 * {label: string, value: string} objects, but get transformed to string arrays for API calls
 */

/**
 * @typedef {Object} ZonesSlice
 * @extends {import('../slice.types').BaseSlice}
 * @property {Object.<string, Zone>} data
 */

export const ZONES_ACTIONS = {
  SET_ZONES: 'SET_ZONES',
  SET_ZONE: 'SET_ZONE',
  REMOVE_ZONE: 'REMOVE_ZONE',
  SET_STATUS: 'SET_ZONES_STATUS',
  SET_ERRORS: 'SET_ZONES_ERRORS',
  CLEAR_ERRORS: 'CLEAR_ZONES_ERRORS'
}

export const initialZonesState = {
  status: 'idle',
  errors: [],
  data: {}
}

export const zonesPropTypes = {
  ...baseSlicePropTypes,
  data: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      notes: PropTypes.string,
      countries: PropTypes.arrayOf(PropTypes.string),
      countries_inclusion_type: PropTypes.string,
      states_provinces_inclusion_type: PropTypes.string,
      states_provinces: PropTypes.arrayOf(PropTypes.string),
      cities_inclusion_type: PropTypes.string,
      cities: PropTypes.string,
      zip_codes_inclusion_type: PropTypes.string,
      zip_codes: PropTypes.string,
      carrier_services: PropTypes.arrayOf(PropTypes.string)
    })
  )
}
